import { createContext } from 'react';

interface GlobalStatusesContextType {
  globalStatuses: string[];
  addGlobalStatus: (status: string) => void;
  removeGlobalStatus: (status: string) => void;
}

const GlobalStatusesContext = createContext<GlobalStatusesContextType>({
  globalStatuses: [],
  addGlobalStatus: () => null,
  removeGlobalStatus: () => null,
});

export default GlobalStatusesContext;
